import { DefaultValues } from 'react-hook-form';
import { FirmMemberFormValues } from '../types';
import { FirmMember } from '../../../../generated/graphql';

export function getFirmMemberFormDefaultValues(
  firmMember: FirmMember | null | undefined,
  defaultValues?: Partial<FirmMemberFormValues>
): DefaultValues<FirmMemberFormValues> {
  if (!firmMember) return { ...defaultValues };

  return {
    calendarSchedulingLink: firmMember.calendarSchedulingLink || null,
    ...defaultValues,
  };
}
